function createElement(tagName = 'div', classList = [], attributes = {}, innerHTML = ''){
  let element = document.createElement(tagName);
  element.classList.add(...classList);
  if(typeof attributes === 'object' && attributes !== null){
    let attributesKeys = Object.keys(attributes);
    for(let i = 0; i < attributesKeys.length; i++ ){
      element.setAttribute(
        attributesKeys[i],
        attributes[attributesKeys[i]]
      );
    }
  }
  element.innerHTML = innerHTML;
  return element;
}

class AppenedItem{
    constructor(dom){
        this.dom = dom
    }
    append(child){
        appendTo(this.dom, child)
    }
    appendList(children){
        for(const child of children){
            if(child){
              this.dom.appendChild(child);        
            }
        }
    }
}

function appendTo(dom, child){
    dom.appendChild(child);
    return new AppenedItem(child)
}

function stopPropagation(event){
  event.stopPropagation()
}

export {
    createElement,
    appendTo,
    stopPropagation,
}